// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lbuH","field":"styles_field__2n8pn","fieldCol":"styles_fieldCol__-hxtZ","diffCol":"styles_diffCol__3MtVl","diff":"styles_diff__2huPt"};